import React from 'react';
import rcss from '../../../../Styles/reports.module.css'

export const InferredTypeNamesBlockView = ({ inferredTypeNames }: { inferredTypeNames: string[]; }) => inferredTypeNames.length === 0 ? null : (
	<div>
		{inferredTypeNames.map((inferredTypeName, index) => (
			<span key={inferredTypeName}>
				{index === 0 ? null : (<span>,&#32;</span>)}
				<span className={rcss.inferredTypeName}>{inferredTypeName}</span>
			</span>
		))}
	</div>
);
